import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterLoadingComponent = ({
  height
}) => /*#__PURE__*/_jsx(Flex, {
  blockSize: `${height || 90}px`
});
export default FilterLoadingComponent;